import { LocalizedContentService } from './domain/LocalizedContentService';
import { CurrencyConversionService } from './domain/CurrencyConversionService';
import { UserSyncService } from './domain/UserSyncService';
import { TuitionFeeDiscountService } from './domain/TuitionFeeDiscountService';

new UserSyncService();
new LocalizedContentService();
new CurrencyConversionService();
new TuitionFeeDiscountService();
